module.exports = __webpack_public_path__ + "img/506d6b0b431e4fa892d8f7427e42ab97.d04f9a52.jpg";